export default function SearcherWindowTemplate(data) {
//language=HTML
    return `
        <div id="window${data.elementId}" class="windowSelect window-select p-0 d-flex flex-column justify-content-between">
            <div class="n-text-right p-2">

                <div class="info">
                    <div class="container-fluid">
                        <div class="nama-collapsable border border-light mb-1">
                            <div class="toggle-info bg-light d-flex justify-content-between p-1">
                                <div class=" mb-1 mb-md-0">
                                    
                                </div>
                                <i class="fa-solid fa-angle-up text-secondary"></i>
                            </div>
        
                            <div class="info-body widgetsList row w-100 m-auto align-items-center">
        
                                <div class="row w-100 mx-auto mb-1 align-items-center pt-1 searchPart">
                                    <div class="col-lg-3 col-md-6">
                                        <div class=" searchInput position-relative mb-1 d-flex w-100 align-items-center" style="border: 1px solid #aaa">
                                            <input class="k-input " style="border: none !important;flex-grow: 1" type="text" id="search-text"
                                                   placeholder=${data.translateId("searchFor")}/>
                                            <a class="search px-2" href="#" id="searchButton"><i class="fa-solid fa-search text-secondary"></i></a>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6">
                                        <input class="w-100" id="searchIn">
                                    </div>
                                    <div class="col-lg-3 col-md-6">
                                        <select id="sortOn" class="w-100 test col-lg-12" multiple="multiple"></select>
                                    </div>
                                    <div class="col-lg-1 col-md-2 col-6 justify-content-center justify-content-md-start" id="ascDescGroup">
                                    </div>
                                    <div class="col-lg-2 col-md-4 col-6 justify-content-center justify-content-md-start" id="conditionsGroup" >
                                    </div>
                                </div>
        
                                <div class="criteriaRoot w-100">
                                    <div class="row w-100 mx-auto mb-1 align-items-center pt-1 ">
                                    </div>
                                    <div id="listScreenFiltering" style="margin-left: 10px">
                                        <div id="listScreenFilteringConditions">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" info">
                    <div class="container-fluid">
                        <div class="details ">
                            <div>
                                <div id="grid" class="searchWindowContent gridSelectInner"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="searcherWindowBtns n-text-left px-2">
                <button class=" k-button rounded-sm" id="insertRowAtEnd">${data.translateId("insertRowAtEnd")}</button>
                <button class=" k-button rounded-sm" id="insertRowsAtEndByOrder">${data.translateId("insertRowsAtEndByOrder")}</button>
                <button class=" k-button rounded-sm" id="insertRow">${data.translateId("insertRow")}</button>
                <button class=" k-button rounded-sm" id="cancel">${data.translateId("cancel")}</button>
                <button class=" k-button rounded-sm" id="ok">${data.translateId("ok")}</button>
            </div>
        </div>`;
}